module.exports = __webpack_public_path__ + "img/ffdsp.1131c5a5.png";